import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import SectionsEditor from '@/components/tearsheets/sections_editor.vue'

export default class extends Controller {
  static targets = ['input', 'mount']

  connect() {
    let initial = []
    try {
      initial = JSON.parse(this.inputTarget.value || '[]')
    } catch {
      initial = []
    }

    this.app = createApp(SectionsEditor, {
      initialSections: initial,
      onChange: sections => {
        this.inputTarget.value = JSON.stringify(sections)
      }
    })
    this.app.mount(this.mountTarget)
  }

  disconnect() {
    this.app?.unmount()
  }
}
